export default __webpack_public_path__ + "static/media/linechart.425396c8.svg";